/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */
import type {
  AdminVariablesListDerivedVariableCacheParams,
  BodyAdminVariablesReuploadLookupTable,
  BodyAdminVariablesUploadLookupTable,
  CreateDerivedVariableRequest,
  DerivedVariableCacheEntry,
  DerivedVariablePreviewRequest,
  DerivedVariablePreviewResponse,
  DerivedVariableSummary,
  ListDerivedVariableCacheResponse,
  ListDerivedVariablesResponse,
  ListLookupTablesResponse,
  LookupCorrelationSuggestionsResponse,
  LookupMatchPreviewResult,
  LookupTableDetail,
  PreviewLookupMatchRequest,
  SuggestColumnCorrelationsRequest,
  UpdateCacheEntryRequest,
  UpdateColumnMappingsRequest,
  UpdateDerivedVariableRequest,
  UpdateLabelRequest,
  UpsertCacheEntryRequest,
  VariableActionResponse,
  VariableCatalogResponse,
  VariableUsageSummary,
} from '../types';

import { axiosInstance } from '../../axiosConfig';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getAdminVariables = () => {
  /**
 * Flat typed organization template-variable catalog for autocomplete/coloring.

Includes built-ins (general / job.* / candidate.* / application.* / call.*), lookup-table
``{{label.column}}`` names, custom (derived) ``{{name}}`` tokens, and bare job/ATS
attribute paths from the org's job schema (``ats.*``, ``location.*``,
``custom_field_values.*``, …). One call feeds script editors, custom-variable prompts, and
the All Variables admin tab.

The catalog is an org-wide schema vocabulary — it answers "is this a real variable?", not
"does a given job have a value?". Both bare ``type=job`` paths and namespaced ``job.*``
built-ins therefore always come from the org vocabulary, identical for every job.
 * @summary List Variable Catalog
 */
  const adminVariablesListVariableCatalog = (
    options?: SecondParameter<typeof axiosInstance<VariableCatalogResponse>>
  ) => {
    return axiosInstance<VariableCatalogResponse>(
      { url: `/admin/variables/catalog`, method: 'GET' },
      options
    );
  };
  /**
   * List all derived variables for the authenticated org (summaries only). Admin-only.
   * @summary List Derived Variables
   */
  const adminVariablesListDerivedVariables = (
    options?: SecondParameter<
      typeof axiosInstance<ListDerivedVariablesResponse>
    >
  ) => {
    return axiosInstance<ListDerivedVariablesResponse>(
      { url: `/admin/variables/custom`, method: 'GET' },
      options
    );
  };
  /**
   * Create a derived variable, rejecting a name already used in the org (409).
   * @summary Create Derived Variable
   */
  const adminVariablesCreateDerivedVariable = (
    createDerivedVariableRequest: CreateDerivedVariableRequest,
    options?: SecondParameter<typeof axiosInstance<DerivedVariableSummary>>
  ) => {
    return axiosInstance<DerivedVariableSummary>(
      {
        url: `/admin/variables/custom`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createDerivedVariableRequest,
      },
      options
    );
  };
  /**
 * Update a derived variable, rejecting a name used by another in the org (409).

A rename is rejected (400) while anything in the org still references the old name, since
those {{old_name}} references would stop resolving.
 * @summary Update Derived Variable
 */
  const adminVariablesUpdateDerivedVariable = (
    derivedVariableId: string,
    updateDerivedVariableRequest: UpdateDerivedVariableRequest,
    options?: SecondParameter<typeof axiosInstance<DerivedVariableSummary>>
  ) => {
    return axiosInstance<DerivedVariableSummary>(
      {
        url: `/admin/variables/custom/${derivedVariableId}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateDerivedVariableRequest,
      },
      options
    );
  };
  /**
   * Soft-delete a derived variable and hard-delete its cache.
   * @summary Delete Derived Variable
   */
  const adminVariablesDeleteDerivedVariable = (
    derivedVariableId: string,
    options?: SecondParameter<typeof axiosInstance<VariableActionResponse>>
  ) => {
    return axiosInstance<VariableActionResponse>(
      { url: `/admin/variables/custom/${derivedVariableId}`, method: 'DELETE' },
      options
    );
  };
  /**
   * Scan all usage of a custom variable across the organization.
   * @summary Get Derived Variable Usages
   */
  const adminVariablesGetDerivedVariableUsages = (
    derivedVariableId: string,
    options?: SecondParameter<typeof axiosInstance<VariableUsageSummary>>
  ) => {
    return axiosInstance<VariableUsageSummary>(
      {
        url: `/admin/variables/custom/${derivedVariableId}/usages`,
        method: 'GET',
      },
      options
    );
  };
  /**
 * Preview a derived variable's value against sample values for its prompt's {{variables}},
deriving lazily and caching on a miss.

Mirrors send-time exactly: the definition's saved ``prompt`` (its instruction, with inline
{{variables}}) is rendered around ``payload.variable_values``, and that rendered prompt is
what the LLM derives from and what the cache is keyed on. This keeps the preview faithful to
what a candidate-facing send would produce.

Admin-only: each unseen rendered prompt triggers a real (billable) LLM call and a cache
write, so the endpoint is gated to admins — the same audience that can create/edit the
definition — to bound who can drive derivation cost.
 * @summary Preview Derived Variable
 */
  const adminVariablesPreviewDerivedVariable = (
    derivedVariableId: string,
    derivedVariablePreviewRequest: DerivedVariablePreviewRequest,
    options?: SecondParameter<
      typeof axiosInstance<DerivedVariablePreviewResponse>
    >
  ) => {
    return axiosInstance<DerivedVariablePreviewResponse>(
      {
        url: `/admin/variables/custom/${derivedVariableId}/preview`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: derivedVariablePreviewRequest,
      },
      options
    );
  };
  /**
 * List a page of cache entries for a derived variable owned by the org. Admin-only: cached
input/output pairs can contain candidate-derived values, so reads are gated like the
rest of this admin feature. Paged (``limit``/``offset``) so a variable with a large cache
can't force loading and serializing every row; ``search`` narrows in SQL so searching
never needs every page.
 * @summary List Derived Variable Cache
 */
  const adminVariablesListDerivedVariableCache = (
    derivedVariableId: string,
    params?: AdminVariablesListDerivedVariableCacheParams,
    options?: SecondParameter<
      typeof axiosInstance<ListDerivedVariableCacheResponse>
    >
  ) => {
    return axiosInstance<ListDerivedVariableCacheResponse>(
      {
        url: `/admin/variables/custom/${derivedVariableId}/cache`,
        method: 'GET',
        params,
      },
      options
    );
  };
  /**
 * Manually add/override a cache mapping (marked as a manual override).

Renders the definition's saved prompt around ``payload.variable_values`` and keys the entry
on the hash of that rendered prompt — identical to preview/send-time derivation — so the
override is guaranteed to match a send-time lookup. A prompt with no {{variables}} is valid
with empty ``variable_values``.
 * @summary Upsert Derived Variable Cache
 */
  const adminVariablesUpsertDerivedVariableCache = (
    derivedVariableId: string,
    upsertCacheEntryRequest: UpsertCacheEntryRequest,
    options?: SecondParameter<typeof axiosInstance<DerivedVariableCacheEntry>>
  ) => {
    return axiosInstance<DerivedVariableCacheEntry>(
      {
        url: `/admin/variables/custom/${derivedVariableId}/cache`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: upsertCacheEntryRequest,
      },
      options
    );
  };
  /**
   * Edit a cache entry's output value (marks it a manual override).
   * @summary Update Derived Variable Cache
   */
  const adminVariablesUpdateDerivedVariableCache = (
    derivedVariableId: string,
    cacheId: string,
    updateCacheEntryRequest: UpdateCacheEntryRequest,
    options?: SecondParameter<typeof axiosInstance<DerivedVariableCacheEntry>>
  ) => {
    return axiosInstance<DerivedVariableCacheEntry>(
      {
        url: `/admin/variables/custom/${derivedVariableId}/cache/${cacheId}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateCacheEntryRequest,
      },
      options
    );
  };
  /**
   * Delete a single cache entry owned by the org's derived variable.
   * @summary Delete Derived Variable Cache
   */
  const adminVariablesDeleteDerivedVariableCache = (
    derivedVariableId: string,
    cacheId: string,
    options?: SecondParameter<typeof axiosInstance<VariableActionResponse>>
  ) => {
    return axiosInstance<VariableActionResponse>(
      {
        url: `/admin/variables/custom/${derivedVariableId}/cache/${cacheId}`,
        method: 'DELETE',
      },
      options
    );
  };
  /**
   * List all lookup tables for the authenticated org (summaries only).
   * @summary List Lookup Tables
   */
  const adminVariablesListLookupTables = (
    options?: SecondParameter<typeof axiosInstance<ListLookupTablesResponse>>
  ) => {
    return axiosInstance<ListLookupTablesResponse>(
      { url: `/admin/variables/lookup`, method: 'GET' },
      options
    );
  };
  /**
 * Upload a labeled CSV: build its schema deterministically, store the blob, and persist.

Rejects an empty label and a duplicate label within the org. Parse failures map to a
400 (the CSV could not be parsed).
 * @summary Upload Lookup Table
 */
  const adminVariablesUploadLookupTable = (
    bodyAdminVariablesUploadLookupTable: BodyAdminVariablesUploadLookupTable,
    options?: SecondParameter<typeof axiosInstance<LookupTableDetail>>
  ) => {
    const formData = new FormData();
    formData.append(`file`, bodyAdminVariablesUploadLookupTable.file);
    formData.append(`label`, bodyAdminVariablesUploadLookupTable.label);

    return axiosInstance<LookupTableDetail>(
      {
        url: `/admin/variables/lookup`,
        method: 'POST',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: formData,
      },
      options
    );
  };
  /**
 * Rename a lookup table, rejecting a label already used by another table in the org.

A rename is also rejected while any asset references the old label's variables
(``{{old_label.column}}``), since those references would stop resolving.
 * @summary Rename Lookup Table
 */
  const adminVariablesRenameLookupTable = (
    csvId: string,
    updateLabelRequest: UpdateLabelRequest,
    options?: SecondParameter<typeof axiosInstance<LookupTableDetail>>
  ) => {
    return axiosInstance<LookupTableDetail>(
      {
        url: `/admin/variables/lookup/${csvId}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateLabelRequest,
      },
      options
    );
  };
  /**
   * Soft-delete a lookup table owned by the authenticated org.
   * @summary Delete Lookup Table
   */
  const adminVariablesDeleteLookupTable = (
    csvId: string,
    options?: SecondParameter<typeof axiosInstance<VariableActionResponse>>
  ) => {
    return axiosInstance<VariableActionResponse>(
      { url: `/admin/variables/lookup/${csvId}`, method: 'DELETE' },
      options
    );
  };
  /**
   * Fetch one lookup table with its schema and a capped row preview.
   * @summary Get Lookup Table
   */
  const adminVariablesGetLookupTable = (
    csvId: string,
    options?: SecondParameter<typeof axiosInstance<LookupTableDetail>>
  ) => {
    return axiosInstance<LookupTableDetail>(
      { url: `/admin/variables/lookup/${csvId}`, method: 'GET' },
      options
    );
  };
  /**
 * Swap an existing table's underlying CSV data, keeping its label and ATS field mappings.

The new CSV's column schema must be a full superset of the current one — every existing
column name must still be present (new columns are allowed). A dropped column would
orphan its ATS field mapping, so a non-superset reupload is rejected (400) listing the
missing columns. Surviving mappings carry forward onto the new schema by column name.
 * @summary Reupload Lookup Table
 */
  const adminVariablesReuploadLookupTable = (
    csvId: string,
    bodyAdminVariablesReuploadLookupTable: BodyAdminVariablesReuploadLookupTable,
    options?: SecondParameter<typeof axiosInstance<LookupTableDetail>>
  ) => {
    const formData = new FormData();
    formData.append(`file`, bodyAdminVariablesReuploadLookupTable.file);

    return axiosInstance<LookupTableDetail>(
      {
        url: `/admin/variables/lookup/${csvId}/reupload`,
        method: 'PUT',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: formData,
      },
      options
    );
  };
  /**
 * Set/clear ATS job-field mappings on a CSV's columns; unmentioned columns are unchanged.

Every column_name must exist in the CSV's schema (400 otherwise). Paths are not
validated against a live ATS schema — the UI sources real fields.
 * @summary Update Column Mappings
 */
  const adminVariablesUpdateColumnMappings = (
    csvId: string,
    updateColumnMappingsRequest: UpdateColumnMappingsRequest,
    options?: SecondParameter<typeof axiosInstance<LookupTableDetail>>
  ) => {
    return axiosInstance<LookupTableDetail>(
      {
        url: `/admin/variables/lookup/${csvId}/column-mappings`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: updateColumnMappingsRequest,
      },
      options
    );
  };
  /**
   * Scan all usage of a lookup table's variables across the organization.
   * @summary Get Lookup Table Usages
   */
  const adminVariablesGetLookupTableUsages = (
    csvId: string,
    options?: SecondParameter<typeof axiosInstance<VariableUsageSummary>>
  ) => {
    return axiosInstance<VariableUsageSummary>(
      { url: `/admin/variables/lookup/${csvId}/usages`, method: 'GET' },
      options
    );
  };
  /**
 * Use an LLM to analyze the CSV's columns and sample rows against available job fields,
suggesting which columns should correlate (join) to ATS job fields and which are output values.
 * @summary Suggest Column Correlations
 */
  const adminVariablesSuggestColumnCorrelations = (
    csvId: string,
    suggestColumnCorrelationsRequest: SuggestColumnCorrelationsRequest,
    options?: SecondParameter<
      typeof axiosInstance<LookupCorrelationSuggestionsResponse>
    >
  ) => {
    return axiosInstance<LookupCorrelationSuggestionsResponse>(
      {
        url: `/admin/variables/lookup/${csvId}/suggest-correlations`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: suggestColumnCorrelationsRequest,
      },
      options
    );
  };
  /**
 * Preview whether a job would match this table, which fields hit or missed, and the row.

Uses the same comparison as send-time matching. Optional ``mappings`` apply unsaved
draft match fields in memory so recruiters can test before saving.
 * @summary Preview Lookup Match
 */
  const adminVariablesPreviewLookupMatch = (
    csvId: string,
    previewLookupMatchRequest: PreviewLookupMatchRequest,
    options?: SecondParameter<typeof axiosInstance<LookupMatchPreviewResult>>
  ) => {
    return axiosInstance<LookupMatchPreviewResult>(
      {
        url: `/admin/variables/lookup/${csvId}/match-preview`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: previewLookupMatchRequest,
      },
      options
    );
  };
  return {
    adminVariablesListVariableCatalog,
    adminVariablesListDerivedVariables,
    adminVariablesCreateDerivedVariable,
    adminVariablesUpdateDerivedVariable,
    adminVariablesDeleteDerivedVariable,
    adminVariablesGetDerivedVariableUsages,
    adminVariablesPreviewDerivedVariable,
    adminVariablesListDerivedVariableCache,
    adminVariablesUpsertDerivedVariableCache,
    adminVariablesUpdateDerivedVariableCache,
    adminVariablesDeleteDerivedVariableCache,
    adminVariablesListLookupTables,
    adminVariablesUploadLookupTable,
    adminVariablesRenameLookupTable,
    adminVariablesDeleteLookupTable,
    adminVariablesGetLookupTable,
    adminVariablesReuploadLookupTable,
    adminVariablesUpdateColumnMappings,
    adminVariablesGetLookupTableUsages,
    adminVariablesSuggestColumnCorrelations,
    adminVariablesPreviewLookupMatch,
  };
};
export type AdminVariablesListVariableCatalogResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getAdminVariables>['adminVariablesListVariableCatalog']
    >
  >
>;
export type AdminVariablesListDerivedVariablesResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getAdminVariables>['adminVariablesListDerivedVariables']
    >
  >
>;
export type AdminVariablesCreateDerivedVariableResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getAdminVariables
      >['adminVariablesCreateDerivedVariable']
    >
  >
>;
export type AdminVariablesUpdateDerivedVariableResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getAdminVariables
      >['adminVariablesUpdateDerivedVariable']
    >
  >
>;
export type AdminVariablesDeleteDerivedVariableResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getAdminVariables
      >['adminVariablesDeleteDerivedVariable']
    >
  >
>;
export type AdminVariablesGetDerivedVariableUsagesResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getAdminVariables
      >['adminVariablesGetDerivedVariableUsages']
    >
  >
>;
export type AdminVariablesPreviewDerivedVariableResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getAdminVariables
      >['adminVariablesPreviewDerivedVariable']
    >
  >
>;
export type AdminVariablesListDerivedVariableCacheResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getAdminVariables
      >['adminVariablesListDerivedVariableCache']
    >
  >
>;
export type AdminVariablesUpsertDerivedVariableCacheResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getAdminVariables
      >['adminVariablesUpsertDerivedVariableCache']
    >
  >
>;
export type AdminVariablesUpdateDerivedVariableCacheResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getAdminVariables
      >['adminVariablesUpdateDerivedVariableCache']
    >
  >
>;
export type AdminVariablesDeleteDerivedVariableCacheResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getAdminVariables
      >['adminVariablesDeleteDerivedVariableCache']
    >
  >
>;
export type AdminVariablesListLookupTablesResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getAdminVariables>['adminVariablesListLookupTables']
    >
  >
>;
export type AdminVariablesUploadLookupTableResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getAdminVariables>['adminVariablesUploadLookupTable']
    >
  >
>;
export type AdminVariablesRenameLookupTableResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getAdminVariables>['adminVariablesRenameLookupTable']
    >
  >
>;
export type AdminVariablesDeleteLookupTableResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getAdminVariables>['adminVariablesDeleteLookupTable']
    >
  >
>;
export type AdminVariablesGetLookupTableResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getAdminVariables>['adminVariablesGetLookupTable']
    >
  >
>;
export type AdminVariablesReuploadLookupTableResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getAdminVariables>['adminVariablesReuploadLookupTable']
    >
  >
>;
export type AdminVariablesUpdateColumnMappingsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getAdminVariables>['adminVariablesUpdateColumnMappings']
    >
  >
>;
export type AdminVariablesGetLookupTableUsagesResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getAdminVariables>['adminVariablesGetLookupTableUsages']
    >
  >
>;
export type AdminVariablesSuggestColumnCorrelationsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getAdminVariables
      >['adminVariablesSuggestColumnCorrelations']
    >
  >
>;
export type AdminVariablesPreviewLookupMatchResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getAdminVariables>['adminVariablesPreviewLookupMatch']
    >
  >
>;
